<template>
  <div>
    <slot :items="items"></slot>
  </div>
</template>

<script>
import api from '@/services/api'
export default {
  name: 'DataFetcher',
  props: {
    endpoint: { type: String, required: true }
  },
  data: () => ({
    items: []
  }),
  methods: {
    async fetchData () {
      try {
        const res = await api.get(this.endpoint)
        this.items = res.data
      } catch (error) {
        throw `${this.endpoint} api service ${error}`
      }
    }
  },
  created () {
    this.fetchData()
  }
}
</script>